import { render, staticRenderFns } from "./LeaveMessageListPage.vue?vue&type=template&id=2805b202&scoped=true"
import script from "./LeaveMessageListPage.vue?vue&type=script&lang=js"
export * from "./LeaveMessageListPage.vue?vue&type=script&lang=js"
import style0 from "./LeaveMessageListPage.vue?vue&type=style&index=0&id=2805b202&prod&lang=less&scoped=true"
import style1 from "./LeaveMessageListPage.vue?vue&type=style&index=1&id=2805b202&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2805b202",
  null
  
)

export default component.exports